import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AuthApi from '../../assets/js/utils/Auth';
import Cookie from '../../assets/js/utils/Cookie';
import { mapStateToProps } from "../../store/reducers/rootReducer";
import { styled } from '@mui/material/styles';
import { manageSessionStyle, classes } from "../../assets/jss/manageSessionStyle";
const ManageSessionRoot = styled(Dialog)(({ theme }) => manageSessionStyle(theme));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
Transition.displayName = "Transition";

class ManageSession extends React.Component {
    constructor(props){
        super(props);

        this.history = this.props.history;
        this.sessionTimeout = null;
        this.tokenExpireTimeout = null;
        this.state = {
            open: false
        };
    }
    componentDidMount(){
        this.setTimout();
    }
    setTimout(){
        if(this.tokenExpireTimeout !== null){
            clearTimeout(this.tokenExpireTimeout);
        }
        const { authorized } = this.props.state;
        if(!authorized){
            return;
        }
        const expireTime = (new Date(parseInt(Cookie.read("mogliAppExpiresIn"))) - new Date());
        if(expireTime <= 0){
            return;
        }
        const beforeTime = 2*60*1000; //2 minutes before expiring
        const timeoutTime = expireTime - beforeTime;
        if(timeoutTime <= 0){
            this.refreshTokens();
            return;
        }
        this.tokenExpireTimeout = setTimeout(() => {
            this.refreshTokens();
            clearTimeout(this.tokenExpireTimeout);
        }, timeoutTime);
    }
    componentWillUnmount(){
        if(this.sessionTimeout !== null){
            clearTimeout(this.sessionTimeout);
        }
        if(this.tokenExpireTimeout !== null){
            clearTimeout(this.tokenExpireTimeout);
        }
    }
    onClose(){
        this.setState({open: false});
    }
    logout(){
        this.onClose();
        clearTimeout(this.tokenExpireTimeout);
        this.history.push("/logout");
    }
    continue(){
        this.onClose();
        this.refreshTokens();
        clearTimeout(this.tokenExpireTimeout);
    }
    refreshTokens(){
        const that = this;
        AuthApi.refreshUserTokens().then((isValidToken) => {
            if(isValidToken !== false){
                // AuthApi.idleRefreshToken();
                that.setTimout();
            }else{
                that.logout();
            }
        }).catch(err => {
            
        });
    }
    render() {
        const { authorized } = this.props.state;
        if(!authorized){
            return null;
        }
        return (
            <ManageSessionRoot
                classes={{
                    root: classes.modalRoot,
                    paper: classes.modal
                }}
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => this.onClose()}
                aria-labelledby="manageSession-slide-title"
                aria-describedby="manageSession-slide-description"
            >   
            <DialogContent
                id="manageSession-slide-description"
                className={classes.modalBody}
            >
                <p>One Moment Please…</p>
            </DialogContent>
        </ManageSessionRoot>
        );
    }
}

ManageSession.propTypes = {
    classes: PropTypes.object,
};

export default connect(mapStateToProps)(ManageSession);